import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { BackButton } from '@twa-dev/sdk/react'
import WebApp from '@twa-dev/sdk'

import { Button, FormInput } from 'components'
import { FlexLayout } from 'layouts'
import { SubscriptionApi } from 'api'
import { notification } from 'services'

import './styles.scss'

const getRawPhone = (phone: string) => phone.replace(/[^\d+]/g, '')

const isPhoneValid = (phone: string) => {
  const digitCount = getRawPhone(phone).length
  return digitCount === 12 && phone.includes('+7')
}

export const PaymentData = () => {
  const { state } = useLocation()
  const [phone, setPhone] = useState('')
  const [loading, setLoading] = useState(false)

  const subscribe = async () => {
    setLoading(true)

    try {
      const { data }: Record<string, any> = await SubscriptionApi.subscribe({
        phone: getRawPhone(phone),
        trial: state?.trial,
        type: state?.type,
      })

      WebApp.openLink(data.data.paymentUrl)
      WebApp.close()
    } catch {
      notification.error('Ошибка при попытке оплаты')
    } finally {
      setLoading(false)
    }
  }

  return (
    <FlexLayout.Container className="payment-container with-mobile-indent" vertical>
      <BackButton />
      <FlexLayout.Content className="scrollable-layout" scrollable>
        <div className="payment-data-card">
          <FormInput
            mask="+7 (999) 999-99-99"
            value={phone}
            onChange={setPhone}
            label="Номер телефона"
            inputMode="numeric"
          />
          <div className="payment-sublabel input-label">для отправки чека</div>
          <Button
            className="payment-button"
            disabled={!isPhoneValid(phone) || loading}
            onClick={subscribe}
          >
            Перейти к оплате
          </Button>
        </div>
      </FlexLayout.Content>
    </FlexLayout.Container>
  )
}
